import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://hidden-sands-44867.herokuapp.com/'
})

export default instance

